import { gql } from '@apollo/client';

export const SEND_REPORT_MUTATION = gql`
  mutation report($galleryId: ID!, $photoId: String!, $input: PublishablePostInput!, $serializer: any) {
    sendReport: publish(galleryId: $galleryId, photoId: $photoId, input: $input)
      @rest(
        type: "Post"
        path: "/galleries/api/galleries/{args.galleryId}/photos/{args.photoId}/report"
        method: "POST"
        endpoint: "bff"
        bodySerializer: $serializer
      ) {
      data {
        status
      }
    }
  }
`;

export type ReportPhotoMutationVariables = {
  galleryId?: string;
  photoId: string;
  input: ReportInput;
  serializer: any;
};

export type ReportInput = {
  reason?: string;
  details?: string;
};

export type ReportPhotoResponseData = {
  data: {
    status: string;
  };
};
